import { render, staticRenderFns } from "./WhatsappDeliveryNavBadge.vue?vue&type=template&id=4a134254&scoped=true&"
import script from "./WhatsappDeliveryNavBadge.vue?vue&type=script&lang=js&"
export * from "./WhatsappDeliveryNavBadge.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappDeliveryNavBadge.vue?vue&type=style&index=0&id=4a134254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a134254",
  null
  
)

export default component.exports